/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import React, { useEffect, useReducer } from "react";
import formReducer from "../../../shared/forms/formReducer";
import FormHandler from "../../../shared/forms/formHandler";
import FieldAutoComplete from "../../../shared/controls/fieldAutoComplete";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import useApiPatios from "../../../api/operaciones/useApiPatios";
import constantes from "../../../catalogos/constantes";
import FieldCheckBox from "../../../shared/controls/fieldCheckBox";
import salidasValidacionEsquema from "./salidasValidacionEsquema";
import { useAuth } from "../../../Seguridad/AuthProvider";
import alerts from "../../../shared/alerts";
import validarUnidadSinOrdenTrabajo from "../../../shared/validarUnidadSinOrdenTrabajo";const SalidasDetalle = ({ onSave, close, operador,  unidad,caja }) => {
    console.log(unidad)
    const api = useApiPatios();
    const { user: usuario } = useAuth();

    const defaultEntity = () => ({
        entity: { id: 0, conCaja: true, nombreSolicitante: usuario.username, otro: false, 
            operador : {
                id: operador?.id,
                nombre: operador?.nombre
            },             
            unidad:    {
                id: unidad?.id,
                nombre: unidad?.numeroEconomico,
                
            },  
            placas: unidad?.placas,         
            caja:    {
                id: caja?.id,
                nombre: caja?.numeroEconomico,
              
            },   
            placasRem: caja?.placas
         },
    });

    const [{ entity, errors }, dispatch] = useReducer(formReducer, {}, defaultEntity);

    const actualizar = (value, propertyName) => {
        dispatch({ type: "update", value: value, name: propertyName });

        if (value?.puedeLlevarCaja === false && propertyName === "unidad") {
            actualizar(false, "conCaja");
        }

        if (propertyName === "esExterno" && value) {
            dispatch({ type: "update", value: "", name: "selloFiscal" });
        }
if (propertyName === "unidad") {
    actualizar(value?.placas ?? "", "placas");
}
if (propertyName === "caja") {
    actualizar(value?.placasRem ?? "", "placasRem");
}
    };
const actualizarUnidad = async (value) => {
    const disponible =
        await validarUnidadSinOrdenTrabajo(api, value);

    if (!disponible) {
        actualizar(null, "unidad");
        return;
    }

    actualizar(value, "unidad");
};
useEffect(() => {
    if (unidad?.id) {
        validarUnidadSinOrdenTrabajo(api, unidad)
            .then(disponible => {
                if (!disponible) {
                    actualizar(null, "unidad");
                }
            });
    }
}, [unidad?.id]);
    const actualizarCaja = async (caja, propertyName) => {
        let selloFiscal;
        actualizar(caja, propertyName);

        if (entity.esExterno) {
            selloFiscal = caja != null ? await api.obtenerSelloFiscalExterno(caja) : "";
        } else {
            selloFiscal = caja != null ? await api.obtenerSelloFiscal(caja.id) : "";
        }
        actualizar(selloFiscal, "selloFiscal");
    };

    const formHandler = new FormHandler({
        validationSchema: salidasValidacionEsquema,
        dispatch,
    });

    const guardar = async () => {
        const existe = await api.validarCajaExterna(entity.nombreCaja, entity.placasRem);

        if (entity.unidad?.id) {
    const disponible =
        await validarUnidadSinOrdenTrabajo(
            api,
            entity.unidad
        );

    if (!disponible) {
        actualizar(null, "unidad");
        return;
    }
}

        if (existe) {
            alerts.aviso('La caja ' + entity.nombreCaja+ ' se encuentra registrada como caja de ABC, favor de revisar la información');
            return;
        } else {
            await formHandler.save(entity, true, api.nuevoPaseSalida);
        }
        if (formHandler.valdation.result) {
            onSave();
        }
    };

    return (
        <>
            <div className="form-container full-height">
                <div className="form-row">
                    <h5 className="col-12">Pase de Salida</h5>

                    {entity.operadorExterno ? (
                        <FieldTextBox
                            name="nombreOperador"
                            label="Nombre Operador"
                            maxLength={800}
                            upperCase
                            colMd={6}
                            required
                            value={entity.nombreOperador}
                            onChange={actualizar}
                            errors={errors}
                        />
                    ) : (
                        <FieldDropDown
                            name="operador"
                            source="empleadosPatios"
                            errors={errors}
                            filter={true}
                            params={{ puestoIds: [constantes.puestos.operador] }}
                            required
                            label="Operador"
                            colMd={6}
                            value={entity.operador}
                            onChange={actualizar}
                        />
                    )}

                    <div className="form-group col-md-6">
                        <label />
                        <FieldCheckBox
                            name="operadorExterno"
                            colMd={12}
                            label="Operador Externo"
                            value={entity.operadorExterno}
                            onChange={actualizar}
                        />
                    </div>

                    <div className="form-group col-md-12" style={{ marginTop: "-20px" }}>
                        <label />
                        <FieldCheckBox
                            name="conCaja"
                            isRadioButton={true}
                            yesOption={"Con remolque"}
                            noOption={"Sin remolque"}
                            disabled={entity.unidad?.puedeLlevarCaja === false}
                            value={entity.conCaja}
                            onChange={actualizar}
                        />
                    </div>

                    {
                    entity.esPermisionario ? (
                        <>
                        <FieldTextBox
                            name="nombreUnidad"
                            label="No. Económico"
                            colMd={4}
                            required
                            value={entity.nombreUnidad}
                            onChange={actualizar}
                            errors={errors}
                        />
                        <FieldTextBox
                            disabled={false}
                            label="*Placas"
                            errors={errors}
                            name="placas"
                            onChange={actualizar}
                            colMd={4}
                            value={entity.placas}
                        />
                        </>
                    ) : (
                        <>
                        <FieldAutoComplete
                            name="unidad"
                            source="unidades"
                            label="No. Económico"
                            required
                            errors={errors}
                            params={{ id: constantes.tiposEquipo.motriz, todasLasEmpresas: true }}
                            colMd={4}
                            value={entity.unidad}
                            onChange={actualizarUnidad}
                        />
                        <FieldTextBox
                            disabled={true}
                            label="*Placas"
                            errors={errors}
                            name="placas"
                            onChange={actualizar}
                            colMd={4}
                            value={entity.placas}
                        />
                        </>
                    )
                    }

                       
                    <div className="form-group col-md-3">
                        
                        <label />
                        <FieldCheckBox
                            name="esPermisionario"
                            label="Permisionario"
                            value={entity.esPermisionario}
                            onChange={actualizar}
                        />
                    </div>
                    
                    {entity.conCaja && (
                            <>
                            
                                {entity.esExterno ? (
                                <FieldTextBox
                                    name="nombreCaja"
                                    label="No. Remolque"
                                    colMd={6}
                                    required
                                    value={entity.nombreCaja}
                                    onChange={(e) => {
                                        const valor = e.replace(/[^a-zA-Z0-9-]/g, '');
                                        console.log(valor); 
                                         actualizarCaja(valor, "nombreCaja");
                                       }} 
                                    errors={errors}
                                />
                                
                                ) : (
                                <FieldAutoComplete
                                    name="caja"
                                    source="unidades"
                                    label="No. Remolque"
                                    required
                                    errors={errors}
                                    params={{ id: constantes.tiposEquipo.arrastre, todasLasEmpresas: true }}
                                    colMd={6}
                                    value={entity.caja}
                                    onChange={actualizarCaja}
                                />
                                )}

                                <div className="form-group col-md-5">
                                <label />
                                <FieldCheckBox
                                    name="esExterno"
                                    label="Externo"
                                    value={entity.esExterno}
                                    errors={errors}
                                    onChange={actualizar}
                                />
                                </div>

                                <FieldTextBox
                                label="Sello Fiscal"
                                colMd={6}
                                value={entity.selloFiscal}
                                disabled
                                />
                                
                                <FieldTextBox
                                disabled={entity.esExterno ? false : true}
                                label="*Placas"
                                errors={errors}
                                name="placasRem"
                                onChange={actualizar}
                                colMd={6}
                                value={entity.placasRem}
                                />
                            </>
                            )}

                </div>

                <div className="form-row">
                    {entity.otro ? (
                        <FieldTextBox
                            name="destino"
                            label="Planta Destino"
                            colMd={6}
                            required
                            value={entity.destino}
                            onChange={actualizar}
                            errors={errors}
                        />
                    ) : (
                        <FieldAutoComplete
                            name="planta"
                            source={`direcciones/${constantes.modulos.paradas}`}
                            label="Planta Destino"
                            required
                            colMd={6}
                            value={entity.planta}
                            onChange={actualizar}
                            errors={errors}
                        />
                    )}

                    <div className="form-group col-md-5">
                        <label />
                        <FieldCheckBox name="otro" label="Otro" value={entity.otro} onChange={actualizar} />
                    </div>

                    <FieldAutoComplete
                        name="cliente"
                        source="clientes"
                        label="Cliente"
                        required
                        errors={errors}
                        colMd={6}
                        value={entity.cliente}
                        onChange={actualizar}
                    />

                    <FieldTextBox label="Solicitante" colMd={6} value={entity.nombreSolicitante} disabled />
                </div>
            </div>
            <div className="form-footer">
                <Button label="Cancelar" className="p-button-outlined" type="button" onClick={close} />
                <Button label="Guardar" type="button" onClick={guardar} />
            </div>
        </>
    );
};

export default SalidasDetalle;
